// extracted by mini-css-extract-plugin
module.exports = {"card":"membershipcard_card__2hXHa"};